import React from 'react';

interface LoadingStateProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
  fullHeight?: boolean;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Cargando datos...',
  size = 'medium',
  className = '',
  fullHeight = true,
}) => {
  const sizeMap = {
    small: 'h-8 w-8 border-2',
    medium: 'h-12 w-12 border-b-2',
    large: 'h-16 w-16 border-b-4',
  };

  const spinnerSize = sizeMap[size];

  return (
    <div
      className={`flex items-center justify-center ${fullHeight ? 'min-h-[400px]' : ''} ${className}`}
    >
      <div className="text-center">
        <div className={`animate-spin rounded-full ${spinnerSize} border-blue-600 mx-auto mb-4`} />
        <p className="text-muted">{message}</p>
      </div>
    </div>
  );
};
